import React, { useState } from "react";

import { useAuth } from "../../context/AuthContext";
import { useStores } from "../../helpers/useStores";
import { ZenModalStep } from '../types/ZenModalStep';

const ZenModal = React.lazy(() => import(/* webpackChunkName: "redesign__components__ZenModal" */ './ZenModal'));
const LoginModal = React.lazy(() => import(/* webpackChunkName: "redesign__components__LoginModal" */"./LoginModal"));

const ZenModalWrapper: React.FC = () => {
  const { UIStore } = useStores();
  const [{ user }] = useAuth();

  return user
    ? (user.valid ? null : <ZenModal onCloseModal={() => UIStore.setShowLoginModal(false)} step={ZenModalStep.WELCOME} />)
    : <LoginModal onCloseModal={() => UIStore.setShowLoginModal(false)} />

};


export default ZenModalWrapper;
